import StateInterface from "../state-interface";

export const on_boarding_title: StateInterface["on_boarding_title"] = {
  options: [],
};
